import merge from "lodash/merge";
import { BasePluginsExtension, BaseSchemaExtension, } from "../extensions/base/extension";
import { BlockquoteExtension } from "../extensions/blockquote/extension";
import { BoldExtension } from "../extensions/bold/extension";
import { CodeExtension } from "../extensions/code/extension";
import { ColorExtension } from "../extensions/color/extension";
import { HighlightExtension } from "../extensions/highlight/extension";
import { HorizontalRuleExtension } from "../extensions/horizontal-rule/extension";
import { ItalicExtension } from "../extensions/italic/extension";
import { ListExtension } from "../extensions/list/extension";
import { PlaceholderExtension, } from "../extensions/placeholder";
import { PopupExtension } from "../extensions/popup/extension";
import { SmallParagraphExtension } from "../extensions/small-paragraph/extension";
import { StrikethroughExtension } from "../extensions/strikethrough/extension";
import { TrailingParagraphExtension, } from "../extensions/trailing-paragraph/extension";
import { UnderlineExtension } from "../extensions/underline/extension";
import { HeadingExtension } from "../extensions/heading/extension";
import { CheckListExtension } from "../extensions/checklist/extension";
import { FormattingToolbarExtension, } from "../extensions/formatting-toolbar/extension";
import { UrlExtension } from "../extensions/url/extension";
import { CalloutExtension } from "../extensions/callout/extension";
import { SlashCommandsExtension } from "../extensions/slash/extension";
import { TableExtension } from "../extensions/table/extension";
import { TocExtension } from "../extensions/toc/extension";
import { MentionExtension } from "../extensions/mention/extension";
import { TabsExtension } from "../extensions/tabs/extension";
import { CodeBlockExtension } from "../extensions/code-block/extension";
import { FilestackExtension, } from "../extensions/filestack";
import { EmojiExtension } from "../extensions/emoji/extension";
import { PillExtension } from "../extensions/pill/extension";
import { DatePillExtension } from "../extensions/date-pill/extension";
import { CollabExtension, } from "../extensions/collab/extension";
import { AiExtension } from "../extensions/ai/extension";
import { ExcalidrawExtension } from "../extensions/exacalidraw/extension";
import { WhiteboardExtension } from "../extensions/whiteboard/extension";
const defaultOptions = {
    formattingToolbar: {
        mode: "floating",
        disableTooltips: false,
    },
    placeholder: {
        placeholderMode: "empty-node",
        placeholder: "Write here...",
        tip: `Tip: Press 'Space' for AI, "/" for commands`,
    },
    extraExtensions: [],
};
/**
 * Create a list of editor extensions, containing all available extensions.
 * Some extensions are disabled while we finish the migration from angular to react.
 */
export function createFullPresetExtensions(options = {}) {
    const { placeholder, trailingParagraph, mentionService, filestackService, formattingToolbar, collab, aiService, excalidrawService, whiteboardService, basePlugins, extraExtensions, } = merge({}, defaultOptions, options);
    return [
        new BaseSchemaExtension(),
        new BoldExtension(),
        new ItalicExtension(),
        new UnderlineExtension(),
        new StrikethroughExtension(),
        new CodeExtension(),
        new SmallParagraphExtension(),
        new ColorExtension(),
        new HighlightExtension(),
        new PlaceholderExtension(placeholder),
        new BlockquoteExtension(),
        new CodeBlockExtension(),
        new EmojiExtension(),
        new HorizontalRuleExtension(),
        new UrlExtension(),
        new PopupExtension(),
        new TrailingParagraphExtension(trailingParagraph),
        new CheckListExtension(),
        new ListExtension(),
        new FormattingToolbarExtension(formattingToolbar),
        new TocExtension(),
        new HeadingExtension(),
        new TableExtension(),
        new CalloutExtension(),
        ...(mentionService ? [new MentionExtension(mentionService)] : []),
        ...(filestackService ? [new FilestackExtension(filestackService)] : []),
        new SlashCommandsExtension(),
        new BasePluginsExtension(basePlugins),
        new TabsExtension(),
        new DatePillExtension(),
        new PillExtension(),
        ...(collab ? [new CollabExtension(collab)] : []),
        ...(aiService ? [new AiExtension(aiService)] : []),
        ...(excalidrawService && filestackService
            ? [new ExcalidrawExtension(excalidrawService, filestackService)]
            : []),
        ...(whiteboardService && filestackService
            ? [new WhiteboardExtension(whiteboardService, filestackService)]
            : []),
        ...(extraExtensions || []),
    ];
}
